import React from 'react';
import { useNavigate } from 'react-router-dom';
import * as S from './index.styled';


const SignUpCompletion: React.FC = () => {
  const navigate = useNavigate();

  const handleLoginRedirect = () => {
    navigate('/');
  };

  return (
    <S.Container>
      <S.Content>
        <S.ImagePlaceholder />
        <S.Message>
          회원가입이 완료되었습니다.
          <br />
          승인이 완료되면 메일로 안내드립니다.
        </S.Message>
        <S.LoginButton onClick={handleLoginRedirect}>
          로그인 이동
        </S.LoginButton>
      </S.Content>
    </S.Container>
  );
};

export default SignUpCompletion;